import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './settings.actions.js';
import getters from './settings.getters.js';
import mutations from './settings.mutations.js';
import state from './settings.state.js';

BaseStore.registerModule('settings', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('settings');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
